// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import NewLeadWithFlow from "./NewLead";
// import NewPayment from "./NewPayment";
// import NewRevenue from "./NewRevenue";
// import { fetchAdmins } from "../../../state/reducers/adminSlice";
// const TabButton = ({ label, isActive, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-3 font-medium text-sm rounded-lg transition-all duration-200 ${
//       isActive
//         ? "bg-blue-600 text-white shadow-md"
//         : "text-gray-600 hover:bg-gray-100"
//     }`}
//   >
//     {label}
//   </button>
// );

// function ReportsContainer() {
//   const dispatch = useDispatch();
//   const { admins, loading, error } = useSelector((state) => state.admin);

//   useEffect(() => {
//     dispatch(fetchAdmins()); // Fetch admins when component mounts
//   }, [dispatch]);
//   const [activeTab, setActiveTab] = useState("leads");
//   const [selectedYear, setSelectedYear] = useState("2023");
//   const [selectedMonth, setSelectedMonth] = useState("All");
//   const [selectedAdmin, setSelectedAdmin] = useState("all");
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

//   const years = ["2023", "2022", "2021"];
//   const months = [
//     "All",
//     "January", "February", "March", "April",
//     "May", "June", "July", "August",
//     "September", "October", "November", "December"
//   ];

//   const renderContent = () => {
//     switch (activeTab) {
//       case "leads":
//         return <NewLeadWithFlow />;
//       case "payments":
//         return <NewPayment />;
//       case "revenue":
//         return <NewRevenue />;
//       default:
//         return <NewLeadWithFlow />;
//     }
//   };

//   return (
//     <div
//       className={`flex-1 bg-gray-50 ${
//         isSideBarOpen ? "ml-80" : "ml-20"
//       } min-h-screen transition-all duration-300`}
//     >
//       {/* Tab Navigation and Filters */}
//       <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
//         <div className="px-6 py-4">
//           {/* Tabs */}
//           <div className="flex space-x-4 mb-6">
//             <TabButton
//               label="Leads"
//               isActive={activeTab === "leads"}
//               onClick={() => setActiveTab("leads")}
//             />
//             <TabButton
//               label="Invoices"
//               isActive={activeTab === "payments"}
//               onClick={() => setActiveTab("payments")}
//             />
//             <TabButton
//               label="Revenue"
//               isActive={activeTab === "revenue"}
//               onClick={() => setActiveTab("revenue")}
//             />
//           </div>

//           {/* Filters */}
//           <div className="grid grid-cols-3 gap-4 bg-white p-4 rounded-lg shadow-sm">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Year
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//               >
//                 {years.map((year) => (
//                   <option key={year} value={year}>
//                     {year}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Month
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//               >
//                 {months.map((month) => (
//                   <option key={month} value={month}>
//                     {month}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//   <label className="block text-sm font-medium text-gray-700 mb-2">
//     Select Admin
//   </label>
//   {error && <p className="text-red-500">{String(error)}</p>} {/* Ensure error is a string */}
//   <select
//     className="w-full p-2 border rounded-md bg-white"
//     value={selectedAdmin}
//     onChange={(e) => setSelectedAdmin(e.target.value)}
//   >
//     <option value="">All Admins</option>
//     {admins.length > 0 ? (
//       admins.map((admin) => (
//         <option key={admin.admin_id} value={admin.username}>
//           {admin.username}
//         </option>
//       ))
//     ) : (
//       <option disabled>No Admins Available</option>
//     )}
//   </select>
// </div>

//           </div>
//         </div>
//       </div>
//       {/* Content Area */}
//       <div className="h-full">
//         {renderContent()}
//       </div>
//     </div>
//   );
// }

// export default ReportsContainer;

// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import NewLeadWithFlow from "./NewLead";
// import NewPayment from "./NewPayment";
// import NewRevenue from "./NewRevenue";
// import { fetchAdmins } from "../../../state/reducers/adminSlice";

// const TabButton = ({ label, isActive, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-3 font-medium text-sm rounded-lg transition-all duration-200 ${
//       isActive
//         ? "bg-blue-600 text-white shadow-md"
//         : "text-gray-600 hover:bg-gray-100"
//     }`}
//   >
//     {label}
//   </button>
// );

// function ReportsContainer() {
//   const dispatch = useDispatch();
//   // Properly destructure all states from admin reducer
//   const { admins, loading: adminsLoading, error: adminsError } = useSelector((state) => state.admin);
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

//   const [activeTab, setActiveTab] = useState("leads");
//   const [selectedYear, setSelectedYear] = useState("2025");
//   const [selectedMonth, setSelectedMonth] = useState("All");
//   const [selectedAdmin, setSelectedAdmin] = useState("all");

//   useEffect(() => {
//     dispatch(fetchAdmins()); // Fetch admins when component mounts
//   }, [dispatch]);

//   const years = ["2026", "2025", "2024", "2023", "2022", "2021"];
//   const months = [
//     "All",
//     "January", "February", "March", "April",
//     "May", "June", "July", "August",
//     "September", "October", "November", "December"
//   ];

//   const renderContent = () => {
//     // Prepare filter props with exact format needed by API
//     const filterProps = {
//       selectedYear: selectedYear,
//       // Convert month to abbreviated format (e.g., "February" to "Feb")
//       selectedMonth: selectedMonth === 'All' ? '' : selectedMonth.substring(0, 3),
//       // Pass the admin ID directly
//       selectedAdmin: selectedAdmin === 'all' ? '' : selectedAdmin
//     };

//     'Sending filters:', filterProps); // Debug log

//     switch (activeTab) {
//       case "leads":
//         return <NewLeadWithFlow {...filterProps} />;
//       case "payments":
//         return <NewPayment {...filterProps} />;
//       case "revenue":
//         return <NewRevenue {...filterProps} />;
//       default:
//         return <NewLeadWithFlow {...filterProps} />;
//     }
//   };

//   return (
//     <div
//       className={`flex-1 bg-gray-50 ${
//         isSideBarOpen ? "ml-80" : "ml-20"
//       } min-h-screen transition-all duration-300`}
//     >
//       <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
//         <div className="px-6 py-4">
//           {/* Tabs */}
//           <div className="flex space-x-4 mb-6">
//             <TabButton
//               label="Leads"
//               isActive={activeTab === "leads"}
//               onClick={() => setActiveTab("leads")}
//             />
//             <TabButton
//               label="Invoices"
//               isActive={activeTab === "payments"}
//               onClick={() => setActiveTab("payments")}
//             />
//             <TabButton
//               label="Revenue"
//               isActive={activeTab === "revenue"}
//               onClick={() => setActiveTab("revenue")}
//             />
//           </div>

//           {/* Filters */}
//           <div className="grid grid-cols-3 gap-4 bg-white p-4 rounded-lg shadow-sm">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Year
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//               >
//                 {years.map((year) => (
//                   <option key={year} value={year}>
//                     {year}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Month
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//               >
//                 {months.map((month) => (
//                   <option key={month} value={month}>
//                     {month}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Admin
//               </label>
//               {adminsLoading ? (
//                 <div className="text-sm text-gray-500">Loading admins...</div>
//               ) : adminsError ? (
//                 <div className="text-sm text-red-500">{adminsError}</div>
//               ) : (
//                 <select
//                   className="w-full p-2 border rounded-md bg-white"
//                   value={selectedAdmin}
//                   onChange={(e) => setSelectedAdmin(e.target.value)}
//                 >
//                   <option value="all">All Admins</option>
//                   {admins && admins.length > 0 && admins.map((admin) => (
//                     <option key={admin.admin_id} value={admin.admin_id}>
//                       {admin.first_name && admin.last_name
//                         ? `${admin.first_name} ${admin.last_name}`
//                         : admin.username}
//                     </option>
//                   ))}
//                 </select>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Content Area */}
//       <div className="h-full">
//         {renderContent()}
//       </div>
//     </div>
//   );
// }

// export default ReportsContainer;

// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import NewLeadWithFlow from "./NewLead";
// import NewPayment from "./NewPayment";
// import NewRevenue from "./NewRevenue";
// import { fetchAdmins } from "../../../state/reducers/adminSlice";

// const TabButton = ({ label, isActive, onClick }) => (
//   <button
//     onClick={onClick}
//     className={`px-6 py-3 font-medium text-sm rounded-lg transition-all duration-200 ${
//       isActive
//         ? "bg-blue-600 text-white shadow-md"
//         : "text-gray-600 hover:bg-gray-100"
//     }`}
//   >
//     {label}
//   </button>
// );

// function ReportsContainer() {
//   const dispatch = useDispatch();
//   const { admins, loading: adminsLoading, error: adminsError } = useSelector((state) => state.admin);
//   const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

//   const [activeTab, setActiveTab] = useState("leads");
//   const [selectedYear, setSelectedYear] = useState("2025");
//   const [selectedMonth, setSelectedMonth] = useState("All");
//   const [selectedAdmin, setSelectedAdmin] = useState("all");

//   useEffect(() => {
//     dispatch(fetchAdmins());
//   }, [dispatch]);

//   // Generate years array dynamically
//   const generateYears = () => {
//     const currentYear = new Date().getFullYear();
//     const years = [];
//     // Include years from currentYear + 2 down to currentYear - 2
//     for (let year = currentYear + 2; year >= currentYear - 2; year--) {
//       years.push(year.toString());
//     }
//     return years;
//   };

//   const years = generateYears();
//   const months = [
//     "All",
//     "January", "February", "March", "April",
//     "May", "June", "July", "August",
//     "September", "October", "November", "December"
//   ];

//   const renderContent = () => {
//     const filterProps = {
//       selectedYear,
//       selectedMonth: selectedMonth === 'All' ? '' : selectedMonth.substring(0, 3),
//       selectedAdmin: selectedAdmin === 'all' ? '' : selectedAdmin
//     };

//     'Selected filters:', filterProps);

//     switch (activeTab) {
//       case "leads":
//         return <NewLeadWithFlow {...filterProps} />;
//       case "payments":
//         return <NewPayment {...filterProps} />;
//       case "revenue":
//         return <NewRevenue {...filterProps} />;
//       default:
//         return <NewLeadWithFlow {...filterProps} />;
//     }
//   };

//   return (
//     <div
//       className={`flex-1 bg-gray-50 ${
//         isSideBarOpen ? "ml-80" : "ml-20"
//       } min-h-screen transition-all duration-300`}
//     >
//       <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
//         <div className="px-6 py-4">
//           {/* Tabs */}
//           <div className="flex space-x-4 mb-6">
//             <TabButton
//               label="Leads"
//               isActive={activeTab === "leads"}
//               onClick={() => setActiveTab("leads")}
//             />
//             <TabButton
//               label="Invoices"
//               isActive={activeTab === "payments"}
//               onClick={() => setActiveTab("payments")}
//             />
//             <TabButton
//               label="Revenue"
//               isActive={activeTab === "revenue"}
//               onClick={() => setActiveTab("revenue")}
//             />
//           </div>

//           {/* Filters */}
//           <div className="grid grid-cols-3 gap-4 bg-white p-4 rounded-lg shadow-sm">
//             {/* Year Filter */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Year
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedYear}
//                 onChange={(e) => setSelectedYear(e.target.value)}
//               >
//                 {years.map((year) => (
//                   <option key={year} value={year}>
//                     {year}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Month Filter */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Month
//               </label>
//               <select
//                 className="w-full p-2 border rounded-md bg-white"
//                 value={selectedMonth}
//                 onChange={(e) => setSelectedMonth(e.target.value)}
//               >
//                 {months.map((month) => (
//                   <option key={month} value={month}>
//                     {month}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Admin Filter */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Select Admin
//               </label>
//               {adminsLoading ? (
//                 <div className="text-sm text-gray-500">Loading admins...</div>
//               ) : adminsError ? (
//                 <div className="text-sm text-red-500">{adminsError}</div>
//               ) : (
//                 <select
//                   className="w-full p-2 border rounded-md bg-white"
//                   value={selectedAdmin}
//                   onChange={(e) => setSelectedAdmin(e.target.value)}
//                 >
//                   <option value="all">All Admins</option>
//                   {admins && admins.length > 0 && admins.map((admin) => (
//                     <option key={admin.admin_id} value={admin.admin_id}>
//                       {admin.first_name && admin.last_name
//                         ? `${admin.first_name} ${admin.last_name}`
//                         : admin.username}
//                     </option>
//                   ))}
//                 </select>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Content Area */}
//       <div className="h-full">
//         {renderContent()}
//       </div>
//     </div>
//   );
// }

// export default ReportsContainer;

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import NewLeadWithFlow from "./NewLead";
import NewPayment from "./NewPayment";
import NewRevenue from "./NewRevenue";
import { fetchAdmins } from "../../../state/reducers/adminSlice";

const TabButton = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    className={`px-6 py-3 font-medium text-sm rounded-md transition-all duration-200 ${
      isActive
        ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-md"
        : "text-gray-600 hover:bg-gray-100 hover:text-blue-600"
    }`}
  >
    {label}
  </button>
);

function ReportsContainer() {
  const dispatch = useDispatch();
  const {
    admins,
    loading: adminsLoading,
    error: adminsError,
  } = useSelector((state) => state.admin);
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

  const [activeTab, setActiveTab] = useState("leads");
  const [selectedYear, setSelectedYear] = useState("2025");
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [selectedAdmin, setSelectedAdmin] = useState("all");

  useEffect(() => {
    dispatch(fetchAdmins());
  }, [dispatch]);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear + 2; year >= currentYear - 2; year--) {
      years.push(year.toString());
    }
    return years;
  };

  const years = generateYears();
  const months = [
    "All",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const renderContent = () => {
    const filterProps = {
      selectedYear,
      selectedMonth:
        selectedMonth === "All" ? "" : selectedMonth.substring(0, 3),
      selectedAdmin: selectedAdmin === "all" ? "" : selectedAdmin,
    };

    switch (activeTab) {
      case "leads":
        return <NewLeadWithFlow {...filterProps} />;
      case "payments":
        return <NewPayment {...filterProps} />;
      case "revenue":
        return <NewRevenue {...filterProps} />;
      default:
        return <NewLeadWithFlow {...filterProps} />;
    }
  };

  return (
    <div
      className={`flex-1 bg-gray-50 ${
        isSideBarOpen ? "ml-80" : "ml-20"
      } min-h-screen transition-all duration-300`}
    >
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="px-6 py-4">
          {/* Tabs */}
          <div className="flex space-x-4 mb-6">
            <TabButton
              label="Leads"
              isActive={activeTab === "leads"}
              onClick={() => setActiveTab("leads")}
            />
            <TabButton
              label="Invoices"
              isActive={activeTab === "payments"}
              onClick={() => setActiveTab("payments")}
            />
            <TabButton
              label="Revenue"
              isActive={activeTab === "revenue"}
              onClick={() => setActiveTab("revenue")}
            />
          </div>

          {/* Filters */}
          <div className="grid grid-cols-3 gap-6 bg-white p-6 rounded-lg shadow-lg">
            {/* Year Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Year
              </label>
              <select
                className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* Month Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Month
              </label>
              <select
                className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                {months.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>

            {/* Admin Filter */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Select Admin
              </label>
              {adminsLoading ? (
                <div className="text-sm text-gray-500">Loading admins...</div>
              ) : adminsError ? (
                <div className="text-sm text-red-500">{adminsError}</div>
              ) : (
                <select
                  className="w-full p-3 border rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  value={selectedAdmin}
                  onChange={(e) => setSelectedAdmin(e.target.value)}
                >
                  <option value="all">All Admins</option>
                  {admins &&
                    admins.length > 0 &&
                    admins.map((admin) => (
                      <option key={admin.admin_id} value={admin.admin_id}>
                        {admin.first_name && admin.last_name
                          ? `${admin.first_name} ${admin.last_name}`
                          : admin.username}
                      </option>
                    ))}
                </select>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="p-6">{renderContent()}</div>
    </div>
  );
}

export default ReportsContainer;
